/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  InteractSubTypes,
  InteractSubLevel,
  SubPeriodTypes,
} from "../../../api/models";

export interface EditSubPricesDialogData {
  dialogTitle: string;
  interactSubTypes: InteractSubTypes[];
  interactSubLevels: InteractSubLevel[];
  subPeriodTypes: SubPeriodTypes[];
  isNew: boolean;
  subscriptionTypeId: number;
  subscriptionLevelId: number;
  periodTypeId: number;
  price: number;
  customTerms: string;
  tax: number;
  clearProposal: boolean;
  proposalFile: File;
  suppressInvoice: boolean;
}

@Component({
  selector: "edit-subscription-price-dialog",
  styleUrls: ["edit-subscription-price-dialog.component.css"],
  templateUrl: "./edit-subscription-price-dialog.component.html",
})
export class EditSubPricesDialogComponent {
  public Result: DialogResult;
  public filteredSubLevels: InteractSubLevel[] = [];

  constructor(
    public dialogRef: MatDialogRef<EditSubPricesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditSubPricesDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  selectedSubTypeChanged() {
    this.filteredSubLevels = [];
    for (var i = 0; i < this.data.interactSubLevels.length; i++) {
      if (
        this.data.interactSubLevels[i].interactSubTypeId ==
        this.data.subscriptionTypeId
      ) {
        this.filteredSubLevels.push(this.data.interactSubLevels[i]);
      }
    }
  }

  handleFileInput(files: FileList) {
    this.data.proposalFile = files.item(0);
  }
}

/* Calling Methods */
/*
  callEditSubPrices(params: EditSubPricesDialogData) {
    var dialogRef = this.dialog.open(EditSubPricesDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
